import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { navForUser } from './nav/navConfig';

// Mobile bottom bar (Sep 2026): mirrors the sidebar structure. Top-level
// entries + the first group tabs fit as icons; everything else lives in a
// role-filtered "More" sheet grouped exactly like the sidebar.
// Bar items: Home · Jobs · Reports (the rest lives in "More").
export const mobileBarItems = (user) => {
  const nav = navForUser(user);
  return [nav.find((n) => n.key === 'home'), nav.find((n) => n.key === 'work')?.items[0], nav.find((n) => n.key === 'reports')].filter(Boolean);
};

// Role-filtered "More" sheet, grouped exactly like the sidebar.
export const MoreSheet = ({ open, onClose }) => {
  const location = useLocation();
  const { user } = useAuth();
  const { t } = useTranslation();
  const nav = navForUser(user);
  const label = (n) => t(n.tKey, n.name);
  const isActive = (path) => location.pathname === path.split('?')[0];
  const setMore = (v) => { if (!v) onClose(); };
  const more = open;
  return (
    <>
      {more && (
        <div className="fixed inset-0 z-[60] bg-black/60" onClick={() => setMore(false)} data-testid="mobile-more-backdrop">
          <div className="absolute bottom-0 left-0 right-0 max-h-[75vh] overflow-y-auto rounded-t-2xl p-4 pb-20" style={{ background: '#0F1923', borderTop: '1px solid #2D3748' }} onClick={(e) => e.stopPropagation()} data-testid="mobile-more-sheet">
            <div className="flex items-center justify-between mb-2">
              <p className="text-white font-semibold">{t('nav.allPages', 'All pages')}</p>
              <button type="button" onClick={() => setMore(false)} className="p-2 text-slate-400" aria-label="Close" data-testid="mobile-more-close"><X className="w-5 h-5" /></button>
            </div>
            {nav.map((n) => (
              <div key={n.key} className="mb-3">
                {n.items ? (
                  <>
                    <p className="px-1 pb-1 text-[10px] font-bold uppercase tracking-[0.14em]" style={{ color: '#4A5568' }}>{label(n)}</p>
                    <div className="grid grid-cols-3 gap-2">
                      {n.items.map((i) => { const I = i.icon; const on = isActive(i.path); return (
                        <Link key={i.key} to={i.path} onClick={() => setMore(false)} data-testid={`mobile-nav-${i.key}`}
                          className="flex flex-col items-center gap-1 py-3 rounded-xl text-xs" style={{ background: on ? '#1E88E5' : '#1A2433', color: on ? '#fff' : '#A0AEC0' }}>
                          <I className="w-5 h-5" /><span className="truncate max-w-full px-1">{label(i)}</span>
                        </Link>
                      ); })}
                    </div>
                  </>
                ) : (() => { const I = n.icon; const on = isActive(n.path); return (
                  <Link to={n.path} onClick={() => setMore(false)} data-testid={`mobile-nav-${n.key}`}
                    className="flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium" style={{ background: on ? '#1E88E5' : '#1A2433', color: on ? '#fff' : '#A0AEC0' }}>
                    <I className="w-5 h-5" />{label(n)}
                  </Link>
                ); })()}
              </div>
            ))}
            <Link to="/user-manual" onClick={() => setMore(false)} className="flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm" style={{ background: '#1A2433', color: '#A0AEC0' }} data-testid="mobile-nav-help">{t('nav.help', 'Help')}</Link>
          </div>
        </div>
      )}
    </>
  );
};

export default MoreSheet;
